import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { RuleIcon } from "./RuleIcon";

export function RulesTopics({ categories, activeSlug, suffix, onSelect }) {
  return (
    <aside className="lg:col-span-4" aria-label="Temas do regulamento">
      <div className="lg:sticky lg:top-24">
        <p className="mb-4 font-mono text-[11px] uppercase tracking-widest text-eden-muted">Escolhe um tema</p>
        <ul className="-mx-5 flex gap-3 overflow-x-auto px-5 pb-3 lg:mx-0 lg:grid lg:grid-cols-1 lg:gap-2 lg:overflow-visible lg:px-0 lg:pb-0" data-testid="rules-sidebar">
          {categories.map((c, i) => {
            const active = c.slug === activeSlug;
            return (
              <li key={c.id} className="w-64 shrink-0 animate-fade-up lg:w-auto" style={{ animationDelay: `${i * 40}ms` }}>
                <Link
                  to={`/regras/${c.slug}${suffix}`}
                  onClick={() => onSelect(c.slug)}
                  aria-current={active ? "true" : undefined}
                  className={`group relative flex h-full items-center gap-4 overflow-hidden rounded-md border p-4 transition-[border-color,background-color,transform] duration-200 ${active ? "border-eden-orange bg-eden-orange/10" : "border-eden-border bg-eden-surface hover:-translate-y-0.5 hover:border-eden-secondary"}`}
                  data-testid={`rules-cat-link-${c.slug}`}
                >
                  <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-sm transition-colors ${active ? "bg-eden-orange text-eden-bg" : "bg-eden-elevated text-eden-orange group-hover:bg-eden-orange/20"}`} data-testid={`rules-cat-icon-${c.slug}`}><RuleIcon category={c} /></span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate font-display text-base font-semibold text-eden-text">{c.title}</span>
                    <span className="mt-0.5 block text-xs text-eden-muted">{c.rules.length} {c.rules.length === 1 ? "regra" : "regras"}{!c.published ? " · rascunho" : ""}</span>
                  </span>
                  <ArrowRight size={16} className={`shrink-0 transition-transform duration-200 ${active ? "text-eden-orange" : "text-eden-muted group-hover:translate-x-0.5"}`} aria-hidden="true" />
                  
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </aside>
  );
}
